import { useEffect, useState } from "react";

import MapPoligons from "components/MapPoligons";
import { calcularAreaPolygonHA, poligonStr2List } from "components/MapPoligons/UtilCalcCordenadas";
import FormContent from "components/form/FormContent";
import FormRow from "components/form/FormRow";
import { useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import Variedade from "entity/Variedade";

export default function PainelTalhaoForm({ areaCultivada, ...props }) {
    const { nome } = props.values;

    const [outrosPoligonos, setOutrosPoligonos] = useState([]);
    const [poligonoStr] = useFieldValue("areaNoMapStr");

    useEffect(() => {
        if (areaCultivada.talhoesFazenda) {
            let ou = [];
            areaCultivada.talhoesFazenda.forEach((t) => {
                let area = t.area || 0;
                if (t.nome !== nome) {
                    if (t.areaNoMapStr) {
                        ou.push({
                            title: t.nome,
                            props: { Área: area, Cultura: areaCultivada.cultura },
                            path: poligonStr2List(t.areaNoMapStr),
                        });
                    }
                }
            });
            setOutrosPoligonos(ou);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const updateArea = () => {
        if (poligonoStr) {
            let novaArea = calcularAreaPolygonHA(poligonStr2List(poligonoStr));
            if (novaArea !== null) {
                props.form.change("area", novaArea.toFixed("2"));
            }
        }
    };

    return (
        <FormContent sx={{ p: 1, flex: 1 }}>
            <FormRow nowrap="true">
                <TextInput name="nome" label="Nome" required />
                <TextInput name="area" type="number" label={"Área"} required />
            </FormRow>

            <FormRow nowrap="true">
                <EntitySearchInput name="variedade" label="Variedade" EntityClass={Variedade} />
            </FormRow>

            <MapPoligons
                name="areaNoMapStr"
                outrosPoligonos={outrosPoligonos}
                updatePoligono={updateArea}
                showCurrentLocation
            />
        </FormContent>
    );
}
